import { Typography, Button } from '@mui/material'
import type { ReactNode } from 'react'
import { Link } from 'react-router'

type NoDataProps = {
  icon: ReactNode
  title: string
  description: ReactNode
  button?: {
    icon: ReactNode
    text: string
    link: string
    state: Record<string, unknown>
    color?: 'primary' | 'secondary' | 'gray_b'
  }
}
const EmptyListTemplate: React.FC<NoDataProps> = ({icon, title, description, button}) =>
  <div style={{
    alignContent: 'center', alignItems: 'center', flexGrow: 1, minHeight: '60vh'
  }}>
    <div style={{textAlign: 'center'}}>
      <span className='material-icons-outlined' style={{fontSize: 48}}>
        {icon}
      </span>
      <br/>
      <Typography color='inherit' variant='h5' fontSize={18} sx={{mb: 1}}>
        {title}
      </Typography>
      {typeof description === 'string' ?
        <Typography color='gray' fontSize={13} whiteSpace='pre-wrap'>
          {description}
        </Typography>
      :
        description
      }
      <br/>
      {button && <Button
        color={button.color || 'gray_b'}
        variant='contained'
        component={Link}
        to={button.link}
        state={button.state}
        startIcon={button.icon}
        sx={{padding: '4px 48px', fontWeight: 'bold'}}
      >
        {button.text}
      </Button>}
    </div>
  </div>

export default EmptyListTemplate